import React from 'react';
import {
    Box,
} from '@saladbob/sassafras';

import getSite from '../../../../crud/getSite';
import getHostBySlug from '../../../../crud/getHostBySlug';
import ScheduleList from '../../../../components/hosts/Schedule';
import Layout from '../../../../components/Layout';
import Blocks from '../../../../components/blocks/Blocks';
import HostLayout from '../../../../components/hosts/Layout';

// Crud
import { publishedByTournament, publishedByTournamentFinished } from '../../../../crud/gql/Brackets';
import fetchGql from '../../../../crud/fetchGql';

import type { NextPageWithLayout, PageProps } from '../../../_app';

import Host from '../../../../types/Host';

type Props = {
    host: Host,
    Header: React.FC,
};

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking', // can also be true or 'blocking'
    }
}

export async function getStaticProps({ params }) {
    if (!params.id || params.id === 'undefined') {
        return {
            notFound: true,
        }
    }

    const site = await getSite();
    const host = await getHostBySlug(process.env.NEXT_PUBLIC_API_URL, params.id);

    if (!host) {
        return {
            notFound: true,
        }
    }

    const brackets = await fetchGql({
        query: host.activeTournament?.status === 'finished' ? publishedByTournamentFinished : publishedByTournament,
        variables: {
            id: host.activeTournament.id,
        },
    });

    return {
        props: {
            metaTitle: host.name,
            bracket: brackets.data.Brackets.docs[0] || null,
            host,
            ...site,
        },
    }
}

const Page: NextPageWithLayout<Props> = ({ host }) => {
    return (<>
        <Box padding={{ phone: 'md', laptop: 'lg' }}>
            <Blocks blocks={host.layout} />
        </Box>
    </>);
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps & Props ) {
    return (
        <Layout { ...pageProps }>
            <HostLayout page="about" {...pageProps}>
                {page}
            </HostLayout>
        </Layout>
    )
}

export default Page;